<template>
  <div
    class="modal fade custom-modal"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <pre class="prompt-box">
  {{ displayText }}
            </pre
          >

          <div v-if="isTruncated" class="text-right mt-2">
            <button class="btn btn-sm btn-outline-primary" @click="toggle">
              {{ expanded ? "Lebih sedikit" : "Lihat selengkapnya" }}
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Tutup
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromptViewerModal",

  props: {
    id: {
      type: String,
      default: "promptModal",
    },
    title: {
      type: String,
      default: "Prompt Viewer",
    },
    text: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 800,
    },
  },

  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    isTruncated() {
      return this.text.length > this.limit;
    },
    displayText() {
      if (this.expanded || !this.isTruncated) {
        return this.text;
      }
      return this.text.substring(0, this.limit) + "\n\n... (dipotong)";
    },
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.prompt-box {
  background: #0f172a;
  color: #e5e7eb;
  padding: 12px;
  border-radius: 6px;
  font-family: "Fira Code", monospace;
  font-size: 13px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/workflow/components/PromptViewerModal.vue